import { FileUploadStatusCode, SetupDetails } from 'components/pages/InventoryManagement/Setup/Setup.types';

import checkmarkIcon from 'assets/icons/check.svg';
import SvgIcon from 'lib/SvgIcon/SvgIcon';
import { Color } from 'lib/SvgIcon/SvgIcon.types';
import warningIcon from 'assets/icons/warning.svg';
import alertIcon from 'assets/icons/info.svg';

import AssetDetails from './AssetDetails';

export interface FileDetailsProps {
  setupDetails: SetupDetails;
}

const StatusColor = {
  [FileUploadStatusCode.FAILED]: 'bg-pinkRed-500',
  [FileUploadStatusCode.ERROR]: 'bg-pinkRed-500',
  [FileUploadStatusCode.SUCCESS]: 'bg-green',
  [FileUploadStatusCode.PARTIAL_FAILURE]: 'bg-yellow-500',
};

const FileDetails = ({
  setupDetails: { hasErrors, fileName, statusCode, setupDetailResponse },
}: FileDetailsProps): React.ReactElement => {
  const fileStatusIcon =
    statusCode === FileUploadStatusCode.FAILED || statusCode === FileUploadStatusCode.ERROR ? alertIcon : checkmarkIcon;

  const bgColor = hasErrors ? 'bg-yellow' : StatusColor[statusCode];

  return (
    <div className="pl-5">
      <div className="flex items-center pb-8">
        <span className={`flex justify-center rounded-full h-10 w-10 mr-6 ${bgColor}`}>
          <SvgIcon src={hasErrors ? warningIcon : fileStatusIcon} color={Color.WHITE} className="self-center" />
        </span>
        <p className="sub-header-lg">
          {fileName.replace(/\.xlsx|\.xls/g, '')}
          <span className="block body-base">
            File has been uploaded {statusCode === FileUploadStatusCode.SUCCESS ? 'successfully' : 'with errors'}
          </span>
        </p>
      </div>
      <div className="max-h-72 overflow-auto">
        {setupDetailResponse.length ? (
          setupDetailResponse.map(
            ({ newRecords, errorRecords, skippedRecords, totalRecords, updatedRecords, entityName }) => (
              <div key={entityName} className="grid gap-x-4 grid-cols-5 text-neutral-950-opacity-80 pb-8">
                <p className="sub-header-base col-span-2">{entityName}</p>
                <div className="space-y-3 col-span-3">
                  <AssetDetails
                    newRecords={newRecords}
                    errorRecords={errorRecords}
                    skippedRecords={skippedRecords}
                    totalRecords={totalRecords}
                    updatedRecords={updatedRecords}
                    isSuccess={FileUploadStatusCode.SUCCESS === statusCode}
                  />
                </div>
              </div>
            ),
          )
        ) : (
          <div className="grid space-y-3 place-items-center" data-test-id="empty-asset-details-component-wrapper">
            <AssetDetails />
          </div>
        )}
      </div>
    </div>
  );
};

export default FileDetails;
